import apiClient from './apiClient';

export interface EsimProfile {
  id: number;
  iccid: string;
  msisdn: string;
  status: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED';
  dataUsed: number;
  dataLimit: number;
  subscriberId?: number;
  activationDate?: Date;
  expirationDate?: Date;
  // Nouveaux champs pour compatibilité avec l'API v1
  simSerial?: string;
  matchingId?: string;
  smdpAddress?: string;
  eid?: string;
  statusDate?: string;
  activationCode?: string;
}

interface ImportProfileData {
  iccid: string;
  msisdn: string;
}

export const esimProfileService = {
  getAll: () => 
    apiClient.get<EsimProfile[]>('/esim-profiles'),

  // Pour l'admin: récupérer les profils eSIM d'un abonné spécifique
  getBySubscriber: (subscriberId: number) =>
    apiClient.get<EsimProfile[]>(`/v1/esim-profiles/subscriber/${subscriberId}`),

  create: (simSerial: string) =>
    apiClient.post<EsimProfile>('/esim-profiles/create', { simSerial }),

  update: (id: number, profile: Partial<EsimProfile>) =>
    apiClient.put<EsimProfile>(`/esim-profiles/${id}`, profile),

  delete: (id: number) =>
    apiClient.delete(`/esim-profiles/${id}`),

  importProfile: (data: ImportProfileData) =>
    apiClient.post<EsimProfile>('/esim-profiles/import', data),

  activate: (id: number) =>
    apiClient.post<EsimProfile>(`/esim-profiles/${id}/activate`)
};